import { useRef } from "react";

/**
 * Keeps the last value a request returned while the next one is in flight.
 *
 * `useReq` blanks its `result` the moment a request starts, so a screen that
 * reloads in place — an admin list refreshing, an event page refetching after
 * a save — would otherwise flash back to its loading or empty state and throw
 * away whatever the user had open. Holding the previous value means the new
 * one simply replaces it when it lands.
 */
export const useLastGood = <T>(result: T | null | undefined): T | null => {
  const lastGood = useRef<T | null>(null);
  if (result) {
    lastGood.current = result;
  }
  return result ?? lastGood.current;
};
